export function getFileExtension(fileUrl: any) {
    const parts = fileUrl.split('.');

    const lastPart = parts[parts.length - 1];
      if (lastPart.length > 0) {
        return lastPart.toLowerCase();
    }
    return null;
  }